import authorized from "@/middleware/authorized"
import paid from '@/middleware/paid'

import CashregisterGeneral from "@/components/pages/cashregister/CashregisterGeneral"

export default {

    path: '/cash-register',
    meta: { middleware: [authorized, paid], layout: "default", rights: ['cashregister'] },
    component: CashregisterGeneral,
    children: [
        { path: '', redirect: '/cash-register/dashboard' },
        {
            path: 'dashboard', name: "CashregisterDashboard",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['cashregister', 'cashregister_dashboard'] },
            component: () => import('../components/pages/cashregister/CashregisterDashboard.vue')
        },
        {
            path: 'report', name: "CashregisterCashReport",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['cashregister', 'cashregister_cashreport'] },
            component: () => import('../components/pages/cashregister/CashregisterCashReport.vue')
        }
    ]
}
